import NextLink from 'next/link';
import { Arrow } from '../SVGs';

interface LinksElementProps {
  href: string;
  children: React.ReactNode;
}

const BlankLink: React.FC<LinksElementProps> = ({ href, children }) => {
  const isExternal = isExternalUrl(href);
  const Element = isExternal ? ExternalLink : NextLink;

  return (
    <Element href={href} className="text-lg tablet:text-2xl">
      <span className="inline-flex gap-4 items-center">
        {children}
        <Arrow
          color="currentColor"
          className="h-[var(--text-lg)] tablet:h-[var(--text-2xl)] w-[var(--text-lg)] tablet:w-[var(--text-2xl)] pt-2 shrink-0"
        />
      </span>
    </Element>
  );
};

export default BlankLink;

const isExternalUrl = (url: string): boolean => {
  return /^https?:\/\//.test(url);
};

const ExternalLink: React.FC<{
  children: React.ReactNode;
  className: string;
  href: string;
}> = ({ children, href, className }) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {children}
    </a>
  );
};
